import { observer } from 'mobx-react';
import { MODIFIER_COLUMN } from '../constants/itemBranchesModifier';
import ColumnTitle from 'src/view/components/ColumnTitle/ColumnTitle';
import { localeStore } from '~/mobx/localesStore';
import { appStore } from '~/mobx/appStore';

interface ITitleProps {
  title: MODIFIER_COLUMN;
  tooltipMessage?: string;
}

const ItemBranchesModifierTitle: React.FC<ITitleProps> = ({ title, tooltipMessage }: ITitleProps) => {
  return <ColumnTitle<MODIFIER_COLUMN> title={title} className={`cell cell-${title}`} tooltipMessage={tooltipMessage} />;
};

const ItemBranchesModifiersTitles = (): JSX.Element => {
  return (
    <div className="d-flex flex-row pr-5 item-branches-modifiers-titles">
      <ItemBranchesModifierTitle title={MODIFIER_COLUMN.BRANCH} />
      <ItemBranchesModifierTitle title={MODIFIER_COLUMN.OPTION_NAME} />
      <ItemBranchesModifierTitle title={MODIFIER_COLUMN.PRICE} />
      <ItemBranchesModifierTitle
        title={MODIFIER_COLUMN.DEFAULT_PRICE}
        tooltipMessage={appStore.isAddonsAvailable.franchise ? localeStore.t('hint_def_cur') : undefined}
      />
      <ItemBranchesModifierTitle title={MODIFIER_COLUMN.AVAILABILITY} />
    </div>
  );
};

export default observer(ItemBranchesModifiersTitles);
